
import Vue, { PropOptions } from 'vue';

export default Vue.extend({
  name: 'DetailsPanelBridge',
  props: {
    isThreadClose: { required: true } as PropOptions<boolean>,
  },
});
